module.exports = __webpack_public_path__ + "img/icon-bank-appswitch.d49774f0.png";